import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import PlayerLoader from "../../components/PlayerLoader";
import { useLexicon } from "../../hooks/useLexicon";

// Phase-2: every unmapped self-serve player belongs on the picker. The legacy
// "ask your team admin to map you" copy was correct for the Phase-1
// invitation flow, but a paying self-serve user can map themselves. This
// page short-circuits to /player/onboarding/pick-player so anything that
// historically linked to /not-mapped (the existing 402 / unmapped
// fall-through paths) lands the user on the actionable page instead.
const PlayerNotMapped = () => {
  const navigate = useNavigate();
  const l = useLexicon();

  useEffect(() => {
    navigate("/player/onboarding/pick-player", { replace: true });
  }, [navigate]);

  return <PlayerLoader label={l(1794)} />;
};

export default PlayerNotMapped;
